var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.arrFiltered),function(row,i){return _c('wrapper-collapse',{key:i,attrs:{"title":row.headerTitle,"initial-open":"","active-class":"border-active-content"}},[_c('card-metodics-file',{attrs:{"items":row.children}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }